import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, notification } from "antd";
import { CheckCircleOutlined, InfoCircleOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, Link } from "react-router-dom";
import moment from "moment";
import { addEditData } from "../../../controllers/V1/raffleDraw/raffleDrawController";
import Loading from "../../../components/Loading/LoadingEffect";

const AddEditRaffleDraw = () => {
  const location = useLocation();
  const state = location.state; // State for edit mode
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [listData, setListData] = useState([]);
  const [initialValues, setInitialValues] = useState(state?{
    place:state?.place,
    prize:state?.prize,
    date:state?.draw_date.split("T")[0],
    time:state?.draw_time,
    from_date:moment(state?.from_date).format('YYYY-MM-DD HH:mm:ss'),
    // from_date:state?.from_date.split("T")[0],
    // from_time: state?.from_date.split("T")[1].split(".")[0],
    // to_date:state?.to_date.split("T")[0],
    to_date:moment(state?.to_date).format('YYYY-MM-DD HH:mm:ss'),
    // to_time:state?.to_date.split("T")[1].split(".")[0]
  }:{});

  const handleSubmit = async (values) => {
    try {
      const { from_date, to_date, ...rest } = values;
      
      const fromDate = moment(from_date).format('YYYY-MM-DD');
      const fromTime = moment(from_date).format('HH:mm:ss');

      const toDate = moment(to_date).format('YYYY-MM-DD');
      const toTime = moment(to_date).format('HH:mm:ss');
      
      // return;
      const formattedValues = {
        ...rest,
        from_date: `${fromDate} ${fromTime}`,
        to_date: `${toDate} ${toTime}`,
        ...(state?._id && { editId: state?._id }),
      };
      const res = await addEditData(formattedValues);
      if (res.status === true) {
        notification.success({
          message: "Success",
          description: "Data successfully added/updated.",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        navigate("/raffle-draw/list");
      } else {
        notification.error({
          message: "Error",
          description: res.message,
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  useEffect(() => {
    document.title = `Orbit Kuwait || Raffle Draw's ${state?._id ? "Edit" : "Add"}`;
  }, [state]);

  return (
    <div className="container-fluid">
      <div className="Inventory_edit_page_main_div">
        <h5 className="inventory_edit_page_heading">
          {state?._id ? "Edit" : "Add"} Raffle Draw
        </h5>
        <Link to="/raffle-draw/list">
          <Button type="secondary">
            <ArrowLeftOutlined /> Back
          </Button>
        </Link>
      </div>

      <div className="card shadow mb-4 dataBase_table_Add_Data">
        <div style={{ padding: "20px" }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={initialValues}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Place"
                  name="place"
                  rules={[{ required: true, message: "Place is required!" }]}
                >
                  <Input placeholder="Please enter place." />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Prize"
                  name="prize"
                  rules={[{ required: true, message: "Prize is required!" }]}
                >
                  <Input placeholder="Please enter prize."/>
                </Form.Item>
              </Col>
          
            </Row>
            <Row gutter={12}>
              <Col span={6}>
                <Form.Item
                  label="Raffle Date"
                  name="date"
                  rules={[{ required: true, message: "Please select a date!" }]}
                >
                  <Input type="date" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Raffle Time"
                  name="time"
                  rules={[{ required: true, message: "Please select a time!" }]}
                >
                  <Input type="time" />
                </Form.Item>
              </Col>
              <Col span={6}>
                  <Form.Item
                    label="From Date"
                    name="from_date"
                    rules={[
                      { required: true, message: "Please select a from date!" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const toDate = getFieldValue("to_date");
                          if (!value || !toDate || value <= toDate) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error("From Date cannot be after To Date!"));
                        },
                      }),
                    ]}
                  >
                    <Input type="datetime-local" />
                  </Form.Item>
              </Col>
              {/* <Col span={4}>
                <Form.Item
                  label="From Time"
                  name="from_time"
                  rules={[
                    { required: true, message: "Please select a from time!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const fromDate = getFieldValue("from_date");
                        const toDate = getFieldValue("to_date");
                        const toTime = getFieldValue("to_time");
                        if (!fromDate || !toDate || fromDate !== toDate || !value || value <= toTime) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("From Time cannot be after To Time!"));
                      },
                    }),
                  ]}
                >
                  <Input type="time" />
                </Form.Item>
              </Col> */}
              <Col span={6}>
                <Form.Item
                  label="To Date"
                  name="to_date"
                  rules={[
                    { required: true, message: "Please select a to date!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const fromDate = getFieldValue("from_date");
                        if (!value || !fromDate || value >= fromDate) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("To Date cannot be before From Date!"));
                      },
                    }),
                  ]}
                >
                  <Input type="datetime-local" />
                </Form.Item>
              </Col>
              {/* <Col span={4}>
                <Form.Item
                  label="To Time"
                  name="to_time"
                  rules={[
                    { required: true, message: "Please select a to time!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const fromDate = getFieldValue("from_date");
                        const toDate = getFieldValue("to_date");
                        const fromTime = getFieldValue("from_time");
                        if (!fromDate || !toDate || fromDate !== toDate || !value || value >= fromTime) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("To Time cannot be before From Time!"));
                      },
                    }),
                  ]}
                >
                  <Input type="time" />
                </Form.Item>
              </Col> */}
            </Row>
            <div className="text-center">
              <Button type="primary" htmlType="submit" className="inventory_save_button">
                Save
              </Button>
            </div>
          </Form>
        </div>
      </div>

      <Loading isLoading={isLoading} />
    </div>
  );
};

export default AddEditRaffleDraw;
